export function validEGPassword(password) {
  const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+|~\-=`{}\[\]:";'<>,.?/\\]).{12,}$/;
  return regex.test(password);
}